import DodoneInnerIgnoreButton from 'app/dodones/shared/InnerIgnoreButton'
import DodoneInnerPendifyButton from 'app/dodones/shared/InnerPendifyButton'
import DodoableDodonesLink from 'app/dodones/shared/DodoableDodonesLink'
import DodoneLink from 'app/dodones/Link'

export default ({ onNav, ignoreDodone, pendifyDodone, ...dodoneContext }) => {
  const dodone = dodoneContext.dodone

  const onIgnoreDodone = useCallback(() => {
    ignoreDodone()
    if (onNav) onNav()
  }, [ignoreDodone, dodone, onNav])

  const onPendifyDodone = useCallback(() => {
    pendifyDodone()
    if (onNav) onNav()
  }, [pendifyDodone, dodone, onNav])

  const isDayDodone = dodone.dodoable.typeViewPrefix == 'Day'
  const hideIgnoreButton = dodone.isIgnored || isDayDodone

  return (
    <>
      <DodoneLink dodoneId={dodone.parentId} className="text-lg" onNav={onNav}>
        Parent
      </DodoneLink>
      <DodoableDodonesLink
        className="text-lg"
        onNav={onNav}
        text={`Log: ${dodone.dodoable.name}`}
        dodoableId={dodone.dodoableId}
      />
      <DodoneInnerPendifyButton
        {...dodoneContext}
        pendifyDodone={onPendifyDodone}
      />
      <DodoneInnerIgnoreButton
        {...dodoneContext}
        ignoreDodone={onIgnoreDodone}
      />
    </>
  )
}
